import { render, staticRenderFns } from "./GameOverRound.vue?vue&type=template&id=0422640c&scoped=true"
import script from "./GameOverRound.vue?vue&type=script&lang=ts"
export * from "./GameOverRound.vue?vue&type=script&lang=ts"
import style0 from "./GameOverRound.vue?vue&type=style&index=0&id=0422640c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0422640c",
  null
  
)

export default component.exports